export const uk = {
    'unhandled-error': 'Во время запроса произошла непредвиденная ошибка'
};
